module.exports = __webpack_public_path__ + "img/2025-06-11c_1.1ba81b15.jpg";